import React, { memo } from 'react';
import { Box, Icon } from '@bonanza-social/moonlight';
import { TabBarIconProps } from './TabBarIcon.types';

function TabBarIcon(props: TabBarIconProps) {
  return (
    <Box justifyContent="center" alignItems="center">
      <Icon alignSelf="center" {...props} />
    </Box>
  );
}

export default memo(TabBarIcon);
